module.exports = __webpack_public_path__ + "/img/Axial-Labeled-TjU0oo.svg";